Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    mastheadMobileShadowOffsetX: 0,
    mastheadMobileShadowOffsetY: 2,
    mastheadMobileShadowBlur: 4,
    mastheadMobileShadowSpread: 0,
    mastheadMobileShadowColor: "rgba(11, 12, 12, 0.16)",
    mastheadBackgroundColor: tokens.themeBackgroundAlternatePrimaryDefault,
    mastheadShadowOffsetX: 0,
    mastheadShadowOffsetY: 4,
    mastheadShadowBlur: 8,
    mastheadShadowSpread: 0,
    mastheadShadowColor: "rgba(11, 12, 12, 0.16)",
    mastheadElevation: 30,
    mastheadSpacingHorizontal: 16,
    mastheadMenuButtonWidth: 32,
    mastheadMenuButtonMotionDuration: "300ms",
    mastheadMenuButtonMotionFunction: "ease",
    mastheadSizeSmall: 36,
    mastheadSizeMedium: 48,
    mastheadSizeLarge: 56,
    mastheadLinkMotionDuration: "100ms",
    mastheadLinkMotionFunction: "ease",
    mastheadLinkSpacingInsetHorizontal: 16,
    mastheadLinkForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    mastheadLinkForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    mastheadLinkBackgroundColorHover: tokens.themeBackgroundAlternatePrimarySelected,
    mastheadLinkBackgroundColorPressed: tokens.themeBackgroundAlternatePrimaryHover,
    mastheadLinkIndicatorColor: tokens.themeForegroundAccentDefault,
    mastheadLinkIndicatorHeight: 4,
    mastheadLinkIndicatorSpacingHorizontal: 4,
    mastheadLinkIndicatorSpacingVerticalDefault: 4,
    mastheadLinkIndicatorSpacingVerticalSmall: 0,
    mastheadLinkIndicatorBorderRadius: 999,
    mastheadBorderWidth: 1,
    mastheadBorderRadius: 0,
    mastheadBorderColor: tokens.themeBorderSecondaryDefault
  }
};